"use client";
import RightArrow from "@/Component/widgets/RightArrow";
import NewSlider from "@/Component/ProductCarousel/NewSlider";
import { ProductDataType } from "@/app/products/tabgen/page";
import C1 from "../../../../public/solution/ins/c1.png";
import C2 from "../../../../public/solution/ins/c2.png";
import C3 from "../../../../public/solution/ins/c3.png";
import C4 from "../../../../public/solution/ins/c4.png";
import { useState } from "react";
import CustomPopup from "@/Component/CustomPopup";
import IndustryInsightsForm from "@/Component/IndustryInsightsForm";

const interceptiQ = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const Interceptiq: ProductDataType[] = [
    {
      header: "",
      description: [
        "Design research resources / library available for quick reference.",
      ],
      image: C1,
      classes: "raven-charts",
    },
    {
      header: "",
      description: ["Real time acquisition and monitoring of data."],
      image: C2,
      classes: "raven-charts",
    },
    {
      header: "",
      description: ["Speak with your data: Integrated GPT module within."],
      image: C3,
      classes: "raven-charts",
    },
    {
      header: "",
      description: ["Comprehensive analysis of Intercept Study's data."],
      image: C4,
      classes: "raven-charts",
    },
  ];
  return (
    <>
      <title>InterceptIQ – Intercept IQ research</title>
      <meta
        name="keywords"
        content="An intercept study is typically conducted at or near the outlet, where customers are intercepted immediately after purchase or consumption to capture fresh, in-the-moment feedback. It is widely used for customer satisfaction, product testing, menu feedback, brand perception, product placement, product availability, service evaluation and many more."></meta>
      <meta
        name="description"
        content="InterceptIQ is an automated process platform for conducting intercept research. The platform can be customised based on the industry or product category of research. "></meta>

      <section className="data-sec mb-x  padding-left-x light-gray-bg">
        <div className="container-fluid">
          <div className="header-container heading-sec research-font-weight res-head">
            <h2>INTERCEPT RESEARCH PLATFORM</h2>
            {/* <h2>RAPID INTERCEPT PLATFORM</h2> */}
            <div className="horizontal-row"></div>
          </div>
          <div className="brand-hedder offering">
            <p>
              An intercept study is typically conducted at or near the outlet,
              where customers are intercepted immediately after purchase or
              consumption to capture fresh, in-the-moment feedback. It is widely
              used for customer satisfaction, product testing, menu feedback,
              brand perception, product placement, product availability, service
              evaluation and many more.
            </p>
          </div>
          <div className="res-offering-bullet">
            <p>It caters to the following key challenges</p>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>Design Research</p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>Survey scripting </p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>In person data collection</p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>Data Platform </p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>Reporting</p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>Recommendation </p>
              </div>
            </div>
            <p>
              InterceptIQ is an automated process platform for conducting
              intercept research. The platform can be customised based on the
              industry or product category of research
            </p>
            <p>The automated process is</p>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>POS System/QR Code/In person data collection </p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>InterceptIQ platform </p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>Dashboard </p>
              </div>
            </div>
            <div className="d-flex right-arrow-hover sec-paragraph arrow-sec quick-arrow">
              <RightArrow />
              <div className="text-container">
                <p>AI Insights </p>
              </div>
            </div>
            <div className="productivity-slider-con_data overflow-hidden pt-0">
              <NewSlider
                productData={Interceptiq}
                pageName={"InterceptiQ"}
                newClass={"image-wrapper-ai"}
                beforeAfterClass={"common-carousel-wrapper bg-color raven-cr "}
              />
            </div>
            <p>
              The in person interviews, survey scripting, data processing and
              reporting are a part of the overall InterceptIQ platform{" "}
              <span
                className="here-click hover-line-effect pointer-cursour"
                onClick={handleModal}>
                Click here for demo
              </span>
            </p>
          </div>
        </div>
      </section>
      <CustomPopup
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        headerText={"How can we help you?"}
        contentBody={<IndustryInsightsForm setIsModalOpen={setIsModalOpen} />}
      />
    </>
  );
};

export default interceptiQ;
